import React, { PropsWithChildren, useMemo } from 'react';
import { TableBodyContext } from './TableBody.context';
import bem from '../../../lib/bemUtils/bem';

type TableBodyProps = {
  modifier?: string;
  id?: string;
  className?: string;
};

export function TableBody({ modifier, id, className, children }: PropsWithChildren<TableBodyProps>) {
  const ctx = useMemo(() => ({ isTableBody: true }), []);
  return (
    <TableBodyContext.Provider value={ctx}>
      {/* we need redundant roles for responsive tables! */}
      <tbody id={id} className={className || bem('tables__body', modifier)}>
        {children}
      </tbody>
    </TableBodyContext.Provider>
  );
}
